module.exports = {
  dev: {
    MODE: 'development',
    BASE_URL: 'http://test-api.jufair.com/api', // 测试环境
    // BASE_URL: 'https://pre-pc.jufair.com/api', // 预发环境
    // BASE_URL: 'https://test.jufair.com/api', // 生产环境
    // BASE_URL: '//m.madkapital.com/api',
    HOST_NAME: 'http://localhost:7001',
    // HOST_NAME: 'https://test-api.jufair.com',
    HOST_NAME_EN: 'http://localhost:7001',
    HOTEL: 'https://hotel-dev.jufair.com',
    VISA: 'https://visa-dev.jufair.com',
    OSS_HOST: 'https://jufair-test.oss-accelerate.aliyuncs.com',
    OSS_HOST_INTERNAL: 'https://jufair-test.oss-accelerate.aliyuncs.com', // 测试环境
    // OSS_HOST: 'https://jufair.oss-accelerate.aliyuncs.com', // 外网
    // OSS_HOST_INTERNAL: 'https://jufair.oss-cn-shanghai-internal.aliyuncs.com', // 内网  生产环境
    // OSS_HOST_INTERNAL: 'https://dcdn-jufair-test.jufair.com' // cdn
  },
  // build:test
  test: {
    MODE: 'test',
    BASE_URL: 'http://jufair-back', // 测试服务器地址
    // BASE_URL: '//m.madkapital.com/api',
    HOST_NAME: 'https://vue.jufair.com',
    // HOST_NAME: '//m.madkapital.com',
    HOST_NAME_EN: 'https://en.jufair.com',
    HOTEL: 'https://hotel-dev.jufair.com',
    VISA: 'https://visa-dev.jufair.com',
    OSS_HOST: 'https://jufair-test.oss-accelerate.aliyuncs.com', // 外网
    OSS_HOST_INTERNAL:
      'https://jufair-test.oss-cn-shanghai-internal.aliyuncs.com', // 内网
  },
  // npm run build MODE=pro
  pro: {
    MODE: 'production',
    BASE_URL: 'http://jufair-back', // 正式服务器地址
    // BASE_URL: '//m.madkapital.com/api',
    HOST_NAME: '//m.madkapital.com',
    HOST_NAME_EN: 'https://en.jufair.com',
    HOTEL: 'https://hotel.jufair.com',
    VISA: 'https://visa.jufair.com',
    OSS_HOST: 'https://jufair.oss-accelerate.aliyuncs.com', // 外网
    OSS_HOST_INTERNAL: 'https://jufair.oss-cn-shanghai-internal.aliyuncs.com', // 内网
  },
  // 预发布环境(生产环境的数据) build:pre MODE=pro
  pre: {
    MODE: 'pre',
    BASE_URL: 'http://jufair-back-pre', // 预发服务器地址 pre-api.jufair.com/api
    // BASE_URL: '//m.madkapital.com/api',
    HOST_NAME: 'https://pre-pc.jufair.com',
    HOST_NAME_EN: 'https://en.jufair.com', // 英文站域名
    HOTEL: 'https://hotel.jufair.com',
    VISA: 'https://visa.jufair.com',
    OSS_HOST: 'https://jufair.oss-accelerate.aliyuncs.com', // 外网
    OSS_HOST_INTERNAL: 'https://jufair.oss-cn-shanghai-internal.aliyuncs.com', // 内网
  },
};
